/* global Tena, imagesLoaded */

(function($) {
    Tena.Header = {
        hideMenuTimer: null,
        init: function() {
            Tena.Header.bindEvents();
        },
        bindEvents: function() {
            var $window = $(window),
                $header = $('.header');
            $window.on('resize', function() {
                Tena.Header.toggleStickyMenu();
                Tena.Header.closeSubmenu();
                Tena.Header.stickyButtons();
                Tena.Header.titleSize();
            });
            $window.on('scroll', function() {
                Tena.Header.toggleStickyMenu();
            });
            $(document).on('mousemove', function(e) {
                var $target = $(e.target),
                    $openSubmenu = $('.submenu-opened:not(.sticky)');
                if (
                    $target.is('.menu-item') ||
                    $target.is('.menu-item a') ||
                    $target.is('.submenu') ||
                    $target.is('.has-submenu') ||
                    $target.closest('.submenu').size() ||
                    $target.closest('.has-submenu').size()
                ) {
                    clearTimeout(window.closeSubmenuTimeout);
                } else if ($openSubmenu.size()) {
                    // Hide
                    clearTimeout(window.closeSubmenuTimeout);
                    window.closeSubmenuTimeout = setTimeout(function() {
                        Tena.Header.closeSubmenu();
                    }, 100);
                }
            });
            $header.on('mouseenter click', '.has-submenu > a', Tena.Header.toggleSubmenu);
            $header.on('mouseenter click', '.submenu', function(e) {
                e.stopPropagation();
            });
            $('body').on('click', function() {
                Tena.Header.closeSubmenu();
            });
            $header.on('mouseenter', '.has-submenu', function() {
                if ($(this).is('.opened') || $header.find('.has-submenu.opened')) {
                    clearTimeout(Tena.Header.hideMenuTimer);
                }
            });
            $header.on('mouseleave', '.has-submenu', function() {
                var $menuItem = $(this),
                    $submenu = $menuItem.find('.submenu');
                if ($menuItem.is('.opened')) {
                    Tena.Header.hideMenuTimer = setTimeout(function() {
                        $menuItem.removeClass('opened');
                        $submenu.hide();
                    }, 450 * 1);
                }
            });
            $window.scroll();
        },
        toggleSubmenu: function() {
            var $link = $(this),
                $submenu = $link.siblings('.submenu');
            Tena.Header.closeSubmenu();
            if (!$link.hasClass('opened')) {
                Tena.Header.openSubmenu($submenu);
            }

            return false;
        },
        openSubmenu: function($targetSubmenu) {
            var $link = $targetSubmenu.siblings('a'),
                $container = $link.closest('.container'),
                $menuWrapper = $container.closest('.menu-wrapper'),
                $submenu = $('.submenu-opened'),
                $columns,
                submenuCSS = {},
                linkOffset;
            $link.addClass('opened');
            linkOffset = $link.width() + $link.offset().left;
            $submenu = $targetSubmenu.clone(true);
            $submenu.addClass('submenu-opened').show();
            if (
                $link.parents('.header-menu').size() &&
                !$submenu.hasClass('submenu-header-menu')
            ) {
                $submenu.addClass('submenu-header-menu');
            } else if ($submenu.hasClass('submenu-header-menu')) {
                $submenu.removeClass('submenu-header-menu');
            }
            if ($menuWrapper.is('.sticky')) {
                submenuCSS.top = $menuWrapper.height();
                submenuCSS.position = 'fixed';
            } else {
                submenuCSS.top =
                    $link.offset().top + $link.height() + 15 - $('.header').offset().top;
            }
            if ($submenu.is('.submenu-login')) {
                $submenu.css(
                    $.extend(
                        {
                            width: '100%',
                            left: 0
                        },
                        submenuCSS
                    )
                );
            } else if ($submenu.is('.other-sites')) {
                var left = $link.offset().left + $link.width() - $targetSubmenu.width();
                $submenu.css(
                    $.extend(
                        {
                            width: $targetSubmenu.width(),
                            left: left
                        },
                        submenuCSS
                    )
                );
            } else {
                $submenu.css(
                    $.extend(
                        {
                            width: $container.width(),
                            left:
                                $container.offset().left +
                                parseInt($container.css('padding-left'))
                        },
                        submenuCSS
                    )
                );
                $columns = $submenu.find('.submenu-content .column');
                var colClassNumber = 12;
                if ($columns.length > 1) {
                    colClassNumber = colClassNumber / $columns.length;
                }
                $.each($columns, function() {
                    var newClassName = $(this).attr('class').replace('4', colClassNumber);
                    $(this).attr('class', newClassName);
                });
                if ($columns.size() < 3) {
                    $submenu.width(
                        $submenu.width() / $columns.size() * $columns.size() + 18
                    );
                    // If the menu link is on the right side of the menu and the
                    // menu has less than three columsn, move the menu over to
                    // the side of the menu item avoid having the submenu arrow
                    // end up outside of the submenu
                    if ($link.offset().left > $container.width() / 2) {
                        $submenu.css({
                            left:
                                $container.offset().left +
                                parseInt($container.css('padding-left')) +
                                $container.width() -
                                $submenu.width()
                        });
                    }
                }
                if ($submenu.width() < linkOffset) {
                    $submenu.width(linkOffset);
                }
            }
            $('.header').prepend($submenu);
            $.event.trigger('submenu.changed', { show: $submenu });
            Tena.Header.showArrow($link, $submenu);
            imagesLoaded($submenu.get(0), function() {
                Tena.Header.fixColumns($submenu);
                Tena.Alignment.alignPushboxContentToBottom($submenu);
            });
        },
        fixColumns: function($submenu) {
            var $columns = $submenu.find('.submenu-content .column'),
                $header = $submenu.find('.submenu-header'),
                $openText = $submenu.find('.submenu-openText'),
                openTextHeight = $openText.size() ? $openText.outerHeight(true) : 0,
                headerHeight = $header.size() ? $header.outerHeight(true) : 0,
                maxHeight = 0;
            $columns.css({ height: 'auto' });
            $columns.each(function() {
                var height = $(this).outerHeight();
                if (height > maxHeight) {
                    maxHeight = height;
                }
            });
            $columns.css({
                height: maxHeight
            });
            $submenu
                .find('.submenu-content')
                .height(maxHeight + headerHeight + openTextHeight);
        },
        showArrow: function($link, $submenu) {
            var $arrow = $submenu.find('.arrow');
            if (!$arrow.size()) {
                $arrow = $('<div class="arrow" />');
                $submenu.prepend($arrow);
            }
            $arrow.css({
                left:
                    $link.offset().left +
                    $link.width() / 2 -
                    $submenu.position().left -
                    $arrow.width() / 2
            });
        },
        closeSubmenu: function() {
            $('.header').find('.submenu-opened').remove();
            $('.has-submenu > a.opened').removeClass('opened');
        },
        toggleStickyMenu: function() {
            var $window = $(window),
                $headerMenu = $('.header-menu'),
                $menuWrapper = $headerMenu.find('.menu-wrapper'),
                $submenu = $('.submenu-header-menu.submenu-opened');
            if ($menuWrapper.length > 0) {
                if (!$menuWrapper.data().defaultOffset) {
                    $menuWrapper.data('default-offset', $menuWrapper.offset().top);
                }
                if ($menuWrapper.is('.sticky')) {
                    if ($window.scrollTop() < $menuWrapper.data().defaultOffset - 0) {
                        $('.sticky-show').fadeOut('100');
                        $menuWrapper.removeClass('sticky');
                        $headerMenu.height('auto');
                        $submenu.css({
                            position: 'absolute',
                            top: $menuWrapper.position().top + $menuWrapper.height()
                        });
                    }
                } else if ($window.scrollTop() >= $menuWrapper.data().defaultOffset - 0) {
                    $('.sticky-show').fadeIn('100');
                    $menuWrapper.addClass('sticky');
                    $headerMenu.height($menuWrapper.height());
                    if ($submenu.size()) {
                        $submenu.css({
                            position: 'fixed',
                            top: $menuWrapper.height()
                        });
                    }
                }
            }
        },
        stickyButtons: function() {
            var widthContentMenu = $('.menu.align-left').width();
            var widthMenuWrapper = $('#ucBreadcrumb_megamenu').width();
            var percent = Math.ceil(widthContentMenu * 100 / widthMenuWrapper);
            if (percent <= 65) {
                $('.StickyButtons').show();
            } else {
                $('.StickyButtons').hide();
            }
        },
        titleSize: function() {
            var TitleCount = $('.mobile-header-title').text().trim().length;
            if (TitleCount >= 20) {
                $('.mobile-header-title').addClass('largestTitle');
            } else if (TitleCount >= 16) {
                $('.mobile-header-title').addClass('largeTitle');
            } else if (TitleCount >= 12) {
                $('.mobile-header-title').addClass('mediumTitle');
            } else if (TitleCount >= 8) {
                $('.mobile-header-title').addClass('smallTitle');
            } else {
                $('.mobile-header-title').addClass('defaultTitle');
            }
        }
    };
})(jQuery);
